module.exports = "# Get Ready to Sing\n\n## Content\n\n### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Standalone Song\nYouTube: JPX85dIOjks\n\n## Notes\n&nbsp;\n\n\n# Combo Intro Song Level 3\nYouTube: zxYmw6Us3X8\n\n## Notes\n&nbsp;\n\n\n# Combo Intro Song Level 4\nYouTube: KnYFFVRQnVc\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/03_song/song.fr_CA.md
// module id = 1673
// module chunks = 2